/* cdds/count_types */
import qs from 'qs'
import instance from '@/helpers/axios'
import moment from 'moment'
import numeral from 'numeral'

const state = {
    cdds_isLoading: false,
    cdds_datasets: [],
    cdds_proportion_type: [],
    cdds_proportion_type_total: [],
    cdds_region_proportion_type: [],
    cdds_region_proportion_type_table: [],
    cdds_region_proportion_type_table_total: [],
    cdds_province_proportion_type_table: [],
    cdds_province_proportion_type: [],
    cdds_district_proportion_type_table: [],
    cdds_district_proportion_type: [],
    cdds_province_list: [],
    cdds_district_list: [],
    cdds_district_detail_table: [],
    cdds_district_detail_table_items: [],

    cdds_all: {},
    cdds_region: {},
    cdds_region_name: '',
    cdds_region_provinces: {},
    cdds_province: {},
    cdds_district: {},
    cdds_rows: {}
}

// getters
const getters = {
    cdds_isLoading: state => {
        return state.cdds_isLoading;
    },
    cdds_datasets: state => {
        return state.cdds_datasets;
    },
    cdds_all: state => {
        return state.cdds_all;
    },
    cdds_proportion_type: state => {
        return state.cdds_proportion_type;
    },
    cdds_proportion_type_total: state => {
        return state.cdds_proportion_type_total;
    },
    cdds_region_proportion_type: state => {
        return state.cdds_region_proportion_type;
    },
    cdds_region_proportion_type_table: state => {
        return state.cdds_region_proportion_type_table;
    },
    cdds_province_proportion_type: state => {
        return state.cdds_province_proportion_type;
    },
    cdds_province_proportion_type_table: state => {
        return state.cdds_province_proportion_type_table;
    },
    cdds_district_proportion_type: state => {
        return state.cdds_district_proportion_type;
    },
    cdds_district_proportion_type_table: state => {
        return state.cdds_district_proportion_type_table;
    },
    cdds_province_list: state => {
        return state.cdds_province_list;
    },
    cdds_district_list: state => {
        return state.cdds_district_list;
    },
    cdds_district_detail_table: state => {
        return state.cdds_district_detail_table;
    },
    cdds_district_detail_table_items: state => {
        return state.cdds_district_detail_table_items;
    },
}

// actions
const actions = {
    getCddsDatasets(context, payload) {
        state.cdds_isLoading = true;
        var _params = {};
        // calulate _params from main_filters                
        var main_filters = payload.main_filters;
        if (main_filters !== null) {
            if (main_filters.start !== null && main_filters.end !== null) {
                _params.start = new Date(main_filters.start).setUTCHours(0, 0, 0, 0);
                _params.end = new Date(main_filters.end).setUTCHours(23, 59, 59, 999);
            }
            if (main_filters.location_source !== null) {
                _params.location_source = main_filters.location_source;
            }
            if (main_filters.location_destination !== null) {
                _params.location_destination = main_filters.location_destination;
            }
            if (main_filters.region !== null) {
                _params.region = main_filters.region;
            }
            if (main_filters.province !== null) {
                _params.province = main_filters.province;
            }
        }
        const request = {
            params: qs.parse(_params)
        };
        // console.log(request);
        // query data
        instance.get('cdds/count_types', request)
            .then(response => {
                const {
                    all,
                    region,

                    region_name,
                    region_provinces,
                    province,
                    district,
                    rows,
                } = response.data;

                // console.log(response.data);

                if (all !== undefined) {
                    state.cdds_all = all;
                    state.cdds_region = region;
                }

                if (region_name !== undefined) {
                    state.region_name = region_name;
                    state.region_provinces = region_provinces;
                }

                if (province !== undefined) {
                    state.province = province;
                    state.district = district;
                    state.rows = rows;
                }

                payload.stateDatasets.forEach(function(stateName) {
                    if (stateName == "cdds_proportion_type") {
                        context.commit("OnCddsProprotionType", payload);
                    } else if (stateName == "cdds_region_proportion_type") {
                        context.commit("OnCddsRegionProprotionType", payload);
                    } else if (stateName == "cdds_province_propotion_type") {
                        context.commit("OnCddsProvinceProprotionType", payload);
                    } else if (stateName == "cdds_district_propotion_type") {
                        context.commit("OnCddsDistrictProprotionType", payload);
                    }
                })
                state.cdds_isLoading = false;
            })
            .catch(error => {
                console.log(error.response, "[store/cdds] syntax errors under instant.get");
            })
    }

}

// mutations
const mutations = {
    // start /v2 mutations
    OnCddsProprotionType(state, payload) {
        // --- start dataset for doughnut chart
        // items = [{data:number,label:string,color:string}]
        // const colors = [
        //     '#3241a6', //blue
        //     '#578e47', //green
        //     '#cf9a41', //yellow
        //     '#be4141', //red
        //     '#7d3b98', //purple
        // ]; 
        var colors = {};
        colors['travel'] = '#3241a6';
        colors['newsevent'] = '#578e47';
        colors['otop'] = '#cf9a41';
        colors['village'] = '#be4141';
        colors['hotel'] = '#7d3b98';
        colors['restaurant'] = '#7ea632';
        colors['tradition'] = '#32a2a6';
        colors['other'] = '#e5e5e5';

        //travel,newsevent,otop,village,hotel,restaurant,tradition,other
        var cdds_all = state.cdds_all;
        var items = [];
        var _total = 0;
        for (const index in colors) {
            var label = cdds_all[index].label;
            var _item = { "data": cdds_all[index].count, "label": cdds_all[index].label, "color": colors[index] };
            items.push(_item);
            _total += _item.data;
        }
        state.cdds_proportion_type = items
        state.cdds_proportion_type_total = [{ "data": _total, "label": "รวมทั้งสิ้น" }];
    },
    OnCddsRegionProprotionType(state, payload) {
        var colors = {};
        colors['travel'] = '#3241a6';
        colors['newsevent'] = '#578e47';
        colors['otop'] = '#cf9a41';
        colors['village'] = '#be4141';
        colors['hotel'] = '#7d3b98';
        colors['restaurant'] = '#7ea632';
        colors['tradition'] = '#32a2a6';
        colors['other'] = '#e5e5e5';

        var cdds_region = state.cdds_region;
        var items = [];
        var _total = {};
        for (const _type in colors) {
            var _item = { 'type': _type };
            for (const _region in cdds_region) {
                _item[_region] = cdds_region[_region][_type].count;
                _item.type = cdds_region[_region][_type].label;
            }
            items.push(_item);
        }

        var _item = { 'type': "รวมทั้งสิ้น" };
        for (const _region in cdds_region) {
            _item[_region] = 0;
            for (const _type in colors) {
                _item[_region] += cdds_region[_region][_type].count;
            }
        }

        state.cdds_region_proportion_type_table = items;
        state.cdds_region_proportion_type_table_total = [_item];

        // --- start dataset for stack chart
        // items = [{label1:0,label2:0,...,date:string}]        
        items = [];
        var _colors = {}
        for (const _region in cdds_region) {
            var _item = {};
            for (const _type in colors) {
                _item[cdds_region[_region][_type].label] = cdds_region[_region][_type].count;
                _colors[cdds_region[_region][_type].label] = colors[_type];
            }
            _item.country = _region;
            items.push(_item);
        }

        // attached colors 
        items.push(_colors);
        state.cdds_region_proportion_type = items;
        // --- end dataset for stack chart

    },
    OnCddsProvinceProprotionType(state, payload) {
        var colors = {};
        colors['travel'] = '#3241a6';
        colors['newsevent'] = '#578e47';
        colors['otop'] = '#cf9a41';
        colors['village'] = '#be4141';
        colors['hotel'] = '#7d3b98';
        colors['restaurant'] = '#7ea632';
        colors['tradition'] = '#32a2a6';
        colors['other'] = '#e5e5e5';

        // province section
        var cdds_region_provinces = state.region_provinces;
        var provinces = [];
        var items = [];
        var total = [];

        for (const _province in cdds_region_provinces) {
            provinces.push({ "text": _province, "value": _province });
            var _total = 0;
            var _item = { "province": _province };
            for (const _type in colors) {
                _item[cdds_region_provinces[_province][_type].label] = cdds_region_provinces[_province][_type].count;
                _total += cdds_region_provinces[_province][_type].count;
            }
            _item["รวมทั้งสิ้น"] = _total;
            items.push(_item);
        }
        state.cdds_province_list = provinces;
        state.cdds_province_proportion_type_table = items;

        // --- start dataset for stack chart
        // items = [{label1:0,label2:0,...,date:string}]        
        items = [];
        var _colors = {}
        for (const _province in cdds_region_provinces) {
            var _item = {};
            for (const _type in colors) {
                _item[cdds_region_provinces[_province][_type].label] = cdds_region_provinces[_province][_type].count;
                _colors[cdds_region_provinces[_province][_type].label] = colors[_type];
            }
            _item.country = _province;
            items.push(_item);
        }

        // attached colors 
        items.push(_colors);
        state.cdds_province_proportion_type = items;
        // --- end dataset for stack chart
    },
    OnCddsDistrictProprotionType(state, payload) {

        var colors = {};
        colors['travel'] = '#3241a6';
        colors['newsevent'] = '#578e47';
        colors['otop'] = '#cf9a41';
        colors['village'] = '#be4141';
        colors['hotel'] = '#7d3b98';
        colors['restaurant'] = '#7ea632';
        colors['tradition'] = '#32a2a6';
        colors['other'] = '#e5e5e5';

        // province section
        var cdds_district = state.district;
        var districts = [];
        var items = [];
        var total = [];

        for (const _district in cdds_district) {
            districts.push({ "text": _district, "value": _district });
            var _total = 0;
            var _item = { "district": _district };
            for (const _type in colors) {
                _item[cdds_district[_district][_type].label] = cdds_district[_district][_type].count;
                _total += cdds_district[_district][_type].count;
            }
            _item["รวมทั้งสิ้น"] = _total;
            items.push(_item);
        }
        state.cdds_district_list = districts;
        state.cdds_district_proportion_type_table = items;

        // --- start dataset for stack chart
        // items = [{label1:0,label2:0,...,date:string}]        
        items = [];
        var _colors = {}
        for (const _district in cdds_district) {
            var _item = {};
            for (const _type in colors) {
                _item[cdds_district[_district][_type].label] = cdds_district[_district][_type].count;
                _colors[cdds_district[_district][_type].label] = colors[_type];
            }
            _item.country = _district;
            items.push(_item);
        }

        // attached colors 
        items.push(_colors);
        state.cdds_district_proportion_type = items;
        // --- end dataset for stack chart

        var cdds_rows = state.rows;
        var data_items = [];
        var items = [];

        for (const _district in cdds_rows) {
            var _index = 0;
            var _rowspan_district = 0;

            for (const _type in cdds_rows[_district]) {
                _rowspan_district += cdds_rows[_district][_type].data.length;
                data_items = data_items.concat(cdds_rows[_district][_type].data);
                var _item = {
                    "index": _index,
                    "district": _district,
                    "type": cdds_rows[_district][_type].label,
                    // "data": cdds_rows[_district][_type].data,
                    "rowspan_district":0,
                    "rowspan_type":cdds_rows[_district][_type].data.length,
                    "data": cdds_rows[_district][_type].data.sort(function(a, b) {
                        return a.name_th.localeCompare(b.name_th);
                    })
                };
                items.push(_item);
                _index++;
            }

        }
        state.cdds_district_detail_table_items = data_items;
        state.cdds_district_detail_table = items;
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}